var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sub-values" }, [
    _c("div", { staticClass: "sub-value" }, [
      _c("div", { staticClass: "label" }, [_vm._v("Stundensatz")]),
      _vm._v(" "),
      _c(
        "div",
        [
          _vm.data && _vm.data.hourlyRate
            ? [_vm._v(_vm._s(_vm.data.hourlyRate) + " €")]
            : [_vm._v("Egal")]
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }